import React from "react";
import useFetch from "../../hooks/useFetch";
import { pls_privacy_policy_api } from "../../api/urls";
import Logo from "../../Assests/plslogo.png";
import Image from "../../components/Image";
const PlsPrivacyPolicy = () => {


  return (
    <main className="main">
      <header className="flex justify-between items-center py-3 md:px-8 px-2 bg-gray-50 shadow-xs sticky top-0">
        <Image src={Logo} alt="Logo" className={"w-[50px]"} />
        <div className="gap-5 flex">
          <a href="/pls/privacy_policy" className="text-violet-800">
            Privacy Policy
          </a>
          <a href="/pls/terms" className="text-violet-800">
            Terms
          </a>
        </div>
      </header>
      <div className="container">
        <Article />
      </div>
    </main>
  );
};

export default PlsPrivacyPolicy;

const SkeletonBox = ({ className }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`} />
);

const Article = () => {
  const { data: privacyData, loading } = useFetch(pls_privacy_policy_api);

  return (
    <div className="flex flex-col gap-4 my-4 min-h-[calc(100vh-300px)]">
      {/* Title Skeleton */}
      {loading
        ? Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="p-5 border">
              <SkeletonBox className="h-8 w-1/3 mb-2" />
            </div>
          ))
        : privacyData?.map((c, i) => (
            <div key={c.id}>
              <h1 className="text-xl font-semibold mt-4 uppercase">
                {i + 1}. {c?.privacytitle}
              </h1>
              <p>{c.content}</p>
            </div>
          ))}
    </div>
  );
};
